<template>
  <div class="container fixed-bottom" v-if="!answered">
    <div class="row">
      <div class="col-1"></div>
      <div class="card col mb-3 p-3 bg-light border">
        <div class="card-body">
          <p class="card-text">Mogen we geanonimiseerde cookies gebruiken voor analyse en statistiek om te helpen de GoAbout calculator verbeteren?</p>
          <div class="btn-group mr-2" role="group">
            <b-button variant="success" v-on:click="accept()">Akkoord</b-button>
            <b-button variant="secondary" v-on:click="deny()">Niet akkoord</b-button>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'analytics',

    data() {
      return {
        enabled: null,
      }
    },

    computed: {
      answered() {
        return this.enabled !== null
      }
    },

    created() {
      this.enabled = localStorage.getItem('ga-enabled')
    },

    watch: {
      enabled(value) {
        localStorage.setItem('ga-enabled', value)
      }
    },

    methods: {
      accept() {
        this.enabled = 'true'
        this.$ga.enable()
        this.$ga.page(this.$router)
      },
      deny() {
        this.enabled = 'false';
        this.$ga.disable()
      }
    }
  }
</script>
